@let isReady = isReady$ | async;
@let isContentLoading = isContentLoading$ | async;

@let isMobile = isDeviceMobile$ | async;
@let isTablet = isDeviceTablet$ | async;

<div class="global-control">
    <web-device-toggle />
</div>
@if (isAiChatEnabled) {
    <button class="ai-chat-btn btn btn-action" [tooltip]="'ai_chat_title' | translate" (click)="showAiChatDrawer()">
        <span class="beta-label">β</span>
        <img src="./assets/img/websites/lpc-ai-chat-icon.svg" />
    </button>
}
<div
    class="constructor-content stripe-bg"
    id="constructorScrollWrapper"
    [class.loading]="isGlobalLoading"
    [class.mobile-mode]="isMobile"
    [class.tablet-mode]="isTablet"
    cdkScrollable
>
    <!--
        Suppressed during an AI reply: the page is re-read once per step now (§4.3), so this loader
        would blink two or three times per reply on top of the blocker below — which is already
        showing a preloader and saying what is happening.
    -->
    @if (isReady && isContentLoading && !isAiSessionActive()) {
        <div class="content-loader">
            <div class="preloader preloader-puff-rounds preloader-lg"></div>
        </div>
    }

    @if (isAiSessionActive()) {
        <div class="ai-session-blocker" data-test="ai-session-blocker">
            <div class="ai-session-blocker__note">
                <div class="preloader preloader-puff-rounds"></div>
                <span>{{ "ai_chat_canvas_blocked" | translate }}</span>
            </div>
        </div>
    }
    <router-outlet></router-outlet>
</div>

<div style="display: none">
    <web-editor content="" widgetId="initial" />
</div>
